import {
  UPDATE_ROL,
  RESET_ROL
} from "./actionTypes"

export const update_rol = rol => {
  return {
    type: UPDATE_ROL,
    payload: rol,
  }
}

export const reset_rol = () => {
  return {
    type: RESET_ROL,
  }
}
